import type { ProductRouter } from "replo-publisher/src/trpc/routers/product";

import { getNamespacedQueryClient } from "@v2/trpc/trpc";

import { createTrpcRouterConfig } from "../config";

const {
  router: productRouter,
  client: productClient,
  utils: productUtils,
  options: productOptions,
} = createTrpcRouterConfig<ProductRouter>({
  path: "product",
  queryClient: getNamespacedQueryClient("product"),
});

export { productClient, productRouter, productUtils, productOptions };
